
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_f8g6q_1h9tp_141",
  "embedded": "awsui_embedded_f8g6q_1h9tp_173",
  "tokens": "awsui_tokens_f8g6q_1h9tp_206",
  "dropdown-header": "awsui_dropdown-header_f8g6q_1h9tp_210",
  "dropdown-footer": "awsui_dropdown-footer_f8g6q_1h9tp_216"
};
  